'use client';

import { useIntl } from 'react-intl';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import Image from 'next/image';

export const LegalHintsImage = () => {
  const { formatMessage } = useIntl();
  const {
    installmentCalculator: { legalHintsImage },
  } = useConfig();

  if (legalHintsImage === null) {
    return null;
  }

  return (
    <div className="border border-[#000]">
      <Image
        src={legalHintsImage.src}
        width={legalHintsImage.width}
        height={legalHintsImage.height}
        alt={formatMessage({
          id: 'legalHintsImage.alt',
          defaultMessage: 'Let op! Geld lenen kost geld',
        })}
        unoptimized
      />
    </div>
  );
};
